import cn from 'classnames'
import { ReactNode, useCallback, useEffect, useRef } from 'react'

export interface NavProps {
  children: ReactNode
  className?: string
  onClickClose: () => void
  isOpen: boolean
}

const Nav = ({ children, className, onClickClose, isOpen }: Props) => {
  const contentElement = useRef<HTMLDivElement>(null)

  const handleMouseDown = useCallback(
    (e: MouseEvent) => {
      if (
        isOpen &&
        contentElement.current !== null &&
        !contentElement.current.contains(e.target as Node)
      ) {
        onClickClose()
      }
    },
    [isOpen, onClickClose],
  )

  useEffect(() => {
    document.addEventListener('mousedown', handleMouseDown)
    return () => {
      document.removeEventListener('mousedown', handleMouseDown)
    }
  }, [contentElement, handleMouseDown, isOpen])

  return (
    <>
      <div
        className={cn(
          'fixed inset-0 bg-black/80 z-[60] transition-opacity duration-300',
          isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none',
        )}
        onClick={onClickClose}
      />

      <nav
        ref={contentElement}
        className={cn(
          'overflow-hidden h-full absolute z-[70] left-0 top-0 bg-white w-0',
          'lg:flex-grow-0 lg:flex-shrink-0 lg:min-w-72 lg:z-20 lg:pt-[68px] font-roboto',
          'transition-all duration-300 shadow-[0_0_0.5rem_rgba(0,0,0,0.15)]',
          { 'w-72': isOpen },
        )}
      >
        <div className={cn('flex flex-col h-full py-2', className)}>
          {children}
        </div>
      </nav>
    </>
  )
}

export default Nav
